import { FindControlInitDto } from 'webcommon/shared';

export type FcItemModalContext = FcNewModal | FcModifyModal | FcNewRelItemModal;

export interface FcItemModalContextBase {
  mode: FcItemModalMode;
  findControlId: string;
  findControlName: string;
  findControlConfig: FindControlInitDto;
  userDefined?: boolean;
}
export interface FcNewModal extends FcItemModalContextBase {
  mode: FcItemModalMode.New;
}

export interface FcItemModalContextWithPrimaryKey extends FcItemModalContextBase {
  selectedFindItemPk: string;
  selectedFindItemName: string;
}
export interface FcModifyModal extends FcItemModalContextWithPrimaryKey {
  mode: FcItemModalMode.Modify;
}

export interface FcNewRelItemModal extends FcItemModalContextWithPrimaryKey {
  mode: FcItemModalMode.NewRelItem;
  webAccessType?: string;
}

export enum FcItemModalMode {
  Modify,
  New,
  NewRelItem, // New item already has primary key
}
